import ActionType from '@actions/type';
import epassportApi from '@apis/epassport';

export default {
  showExportDialog() {
    return {
      type: ActionType.EPASSPORT_SHOW_EXPORT_DIALOG,
    };
  },
  hideExportDialog() {
    return {
      type: ActionType.EPASSPORT_HIDE_EXPORT_DIALOG,
    };
  },
  startExportData(data) {
    return (dispatch) => {
      dispatch({
        type: ActionType.EPASSPORT_EXPORT_DATA_LOADING,
        data,
      });
      epassportApi.exportData(data).then((res) => {
        if (res.status === 0) {
          dispatch({
            type: ActionType.EPASSPORT_EXPORT_DATA_SUCCESS,
            result: res.data,
          });
          document.location.reload();
        } else {
          dispatch({
            type: ActionType.EPASSPORT_EXPORT_DATA_FAIL,
            error: res.message,
          });
        }
      });
    };
  },
  bindAccount(id) {
    return {
      type: ActionType.DIST_BIND_EBOOKING_SUCCESS,
      id,
    };
  },
  heightResizeWithCode(code) {
    return {
      type: ActionType.EPASSPORT_HEIGHT_RESIZE,
      code,
    };
  },
};



// WEBPACK FOOTER //
// ./actions/epassport.js